const Builder = require('./BuilderBase');
const ShortText = require('./formElements/ShortText');

module.exports = class InvisibleElement extends Builder {
    constructor(title, properties) {
        super('formElement_InvisibleElement', title, properties);
    }

    shortText(title, properties) {
        let shortText = new ShortText(title, properties);
        this.addChildBlock(shortText, 'nestedInvisibleElements');
        return shortText;
    }
};
